import React, {useEffect} from 'react'

const Page404 = () => {

  useEffect(() => {
    document.title = "404 | Page Not Found"
  }, [])

  return (
    <div>Page404</div>
  )
}

export default Page404